import { useEffect, useState } from 'react';

// Stable IDs, independent of ordering/filtering/pagination. Never cross business/tenant boundaries.
export default function useDocumentSelection(scope) {
  const [state, setState] = useState({ scope, rows: {} });
  useEffect(() => { setState(previous => previous.scope === scope ? previous : { scope, rows: {} }); }, [scope]);
  const rows = state.scope === scope ? state.rows : {};
  const change = callback => setState(previous => ({ scope, rows: callback(previous.scope === scope ? previous.rows : {}) }));
  return {
    selected: Object.values(rows), count: Object.keys(rows).length,
    has: id => Boolean(rows[id]),
    toggle: row => change(previous => { const next = { ...previous }; if (next[row.Id]) delete next[row.Id]; else next[row.Id] = row; return next; }),
    toggleFiltered: filtered => change(previous => {
      const next = { ...previous }, remove = filtered.length > 0 && filtered.every(row => next[row.Id]);
      filtered.forEach(row => { if (remove) delete next[row.Id]; else next[row.Id] = row; }); return next;
    }),
    clear: () => change(() => ({})),
    targets: row => Object.keys(rows).length ? Object.values(rows) : [row],
  };
}
